var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "card-collapse", attrs: { shadow: "hover" } },
        [
          _c(
            "el-col",
            { staticClass: "center", attrs: { span: 8 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Nome do Interessado:",
                  content: _vm.vtn.processoSicarf.nomeRazaoSocialInteressado
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Número do processo:",
                  content: _vm.vtn.processoSicarf.numeroProcesso
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("app-display", {
                attrs: {
                  label: "CPF do Interessado:",
                  content: _vm.vtn.processoSicarf.cpfCnpjInteressado
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Tipo de Processo:",
                  content: _vm.vtn.processoSicarf.tipo.nome
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "card-collapse", attrs: { shadow: "hover" } },
        [
          _c(
            "el-row",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Tipo:",
                      content:
                        _vm.vtn.formaPagamento === "A_VISTA"
                          ? "À vista"
                          : "À prazo"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Valor principal:",
                      content: _vm.formatReal(_vm.vtn.calculosVtn.vtn)
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _vm.vtn.formaPagamento === "PARCELADO"
                    ? _c("app-display", {
                        attrs: {
                          label: "Valor desconto:",
                          content: _vm.formatReal(
                            _vm.vtn.calculosVtn.descontoTemDireito +
                              _vm.vtn.calculosVtn.descontoRespeita
                          )
                        }
                      })
                    : _vm._e(),
                  _vm.vtn.formaPagamento === "A_VISTA"
                    ? _c("app-display", {
                        attrs: {
                          label: "Valor desconto:",
                          content: _vm.formatReal(
                            _vm.vtn.calculosVtn.descontoAVista
                          )
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Valor total:",
                      content: _vm.formatReal(
                        _vm.vtn.calculosVtn.vtnComDesconto ||
                          _vm.vtn.calculosVtn.vtn
                      )
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Status da VTN:",
                      content: _vm.vtn.statusVtn
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Quantidades de DAEs emitidos:",
                      content: _vm.vtn.boletos.length
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _vm.vtn.formaPagamento === "A_VISTA" &&
                  _vm.vtn.statusVtn === "Em aberto"
                    ? _c("app-display", {
                        attrs: {
                          label: "Prazo de carência:",
                          content: _vm.vtn.prazoCarencia + " dia(s)"
                        }
                      })
                    : _vm._e(),
                  _vm.vtn.formaPagamento === "PARCELADO"
                    ? _c("app-display", {
                        attrs: {
                          label: "Quantidade de parcelas:",
                          content: _vm.vtn.quantidadeParcelas
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "table-boletos",
              attrs: { data: _vm.vtn.boletos, stripe: "stripe" }
            },
            [
              _c("el-table-column", {
                attrs: { width: "100", prop: "numeroVia", label: "Nº Via Dae" }
              }),
              _c("el-table-column", {
                attrs: {
                  width: "200",
                  prop: "dataCriacao",
                  label: "Data Emissão"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  width: "200",
                  prop: "dataVencimento",
                  label: "Data Vencimento"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receita.tipoReceita.descricao",
                  label: "Receita"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "situacao",
                  label: "Status",
                  formatter: _vm.formatSituacao
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "valorPrincipal",
                  label: "Valor",
                  formatter: _vm.formatValor
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-button",
        {
          attrs: { type: "default", icon: "el-icon-arrow-left" },
          on: { click: _vm.voltar }
        },
        [_vm._v("Voltar")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8944004c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8944004c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/VisualizarDAEs.vue
// module id = null
// module chunks = 